import React from 'react'
import styled, { css } from 'styled-components'
import { addResponsivity, up } from '../lib/styles'

const Row = styled.div`
  ${({
    theme: { colors },
    responsive,
    alignItems,
    alignSelf,
    justifyContent,
    mobileAlignItems,
    maxWidth,
    position,
    margin,
    mobileMargin,
    padding,
    mobilePadding,
    wrap,
    mobileWrap,
    width,
    shrink,
    mobileWidth,
    height,
    basis,
    bp = 'mobile',
    mobileFlexDirection,
  }) => css`
    display: flex;
    flex-basis: ${basis};
    align-items: ${mobileAlignItems || alignItems};
    align-self: ${alignSelf};
    justify-content: ${justifyContent};
    max-width: ${maxWidth};
    width: ${mobileWidth || width};
    height: ${height};
    position: ${position};
    flex-shrink: ${shrink};
    margin: ${mobileMargin || margin};
    padding: ${mobilePadding || padding};
    flex-wrap: ${mobileWrap || wrap};

    flex-direction: ${
  mobileFlexDirection || (responsive ? 'column' : 'row')
};

    ${up(bp)} {
      width: ${width};
      flex-direction: row;
      margin: ${margin};
      padding: ${padding};
      align-items: ${alignItems};
      flex-wrap: ${wrap};
    }
/* 
    ${responsive
      && css`
        flex-wrap: wrap;
      `} */



    ${addResponsivity({ displayAs: 'flex' })}
  `}
`

export default Row
